import { connect } from 'react-redux';

import { setModalClosed } from 'actions/modal-actions';
import { getModalOpen } from 'store/reducers/modal';
import { getTilesPerRow } from 'store/reducers/content';
import { setUpcomingTracks } from 'actions/player-actions';

import Collection, { CollectionProps } from './Collection';
import { State } from 'redux';

const mapStateToProps = (state: State, ownProps: CollectionProps) => {
  return {
    modalIsOpen: getModalOpen(state),
    itemsPerRow: ownProps.itemsPerRow || getTilesPerRow(state, ownProps),
    // display: ownProps.display,
  };
};

const mapDispatchToProps = {
  onCollectionClosed: setModalClosed,
  setUpcomingTracks,
};

export default connect(mapStateToProps, mapDispatchToProps)(Collection);
